// extracted by mini-css-extract-plugin
module.exports = {"items_list":"Jobs_items_list__2Tisz","item":"Jobs_item__2ZZVz","info":"Jobs_info__2xw7v"};